import { Component, Prop } from "@eastsideco/salvo-ts";
import { ThemeComponent } from "@/theme/ThemeComponent";

@Component
export class LoyaltyTierBenefits extends ThemeComponent {
    @Prop points!: number[];

    init(){
        const target = document.querySelector('div[data-lion-tier-benefits-compare]') as HTMLElement;

        const observer = new MutationObserver(() => {
            if (document.getElementById('loyaltylion')) {
                this.process();
                observer.disconnect();
            }
        });

        const config = { childList: true };

        observer.observe(target, config);
    }

    process() {
        const headerCell = document.querySelector('.lion-tier-compare__header-cell') as HTMLElement;

        if(!headerCell) {
            return;
        }

        headerCell.textContent = 'Perks';

        const firstCompareRow = document.querySelector('.lion-tier-benefits-compare__row') as HTMLElement;

        if(!firstCompareRow) {
            return;
        }

        const cells = firstCompareRow.querySelectorAll('.lion-tier-benefits-compare__benefit-status ');

        if(!cells) {
            return;
        }

        for(const [i, v] of cells.entries()) {
            v.textContent = `${this.points[i]}`;
        }

    }
}

